import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchSpeakerActiveStatus } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const speakerActiveStatusSlice = createAsyncThunk('get/speakerActiveStatusSlice', FetchSpeakerActiveStatus);

export const SpeakerActiveStatusSlice = createSlice({
	name: 'speakerActiveStatusSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[speakerActiveStatusSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[speakerActiveStatusSlice.rejected.toString()]: setAPIError,
		[speakerActiveStatusSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[SpeakerActiveStatusSlice.name]: ReturnType<typeof SpeakerActiveStatusSlice.reducer>;
}

export const speakerActiveStatusSelector = (state: IStates): any => {
	return state[SpeakerActiveStatusSlice.name] || {};
};

export const useSpeakerActiveStatus = (): any => useSelector(speakerActiveStatusSelector);

export const getSpeakerActiveStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(speakerActiveStatusSlice());
		return;
	};

export const resetSpeakerActiveStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(SpeakerActiveStatusSlice.actions.RESET());
		return;
	};
